/*
 * ICX Portal integration code
 */

import jwtDecode from 'jwt-decode';
import { throttle } from 'lodash';
import { isDevMode } from './index';
import { parse, stringify } from '../components/forked/stringify';

let portalMode = false;

/**
 * ICX message handler (posted from ICX portal to iFrame)
 * @param {*} eventData
 * @param callBack
 */
const receiveMessageFromIcx = (eventData, callBack) => {
  //NOSONAR
  if (eventData.action === 'updateIccApiToken') {
    let icapitoken = eventData.data;

    const jwt = jwtDecode(icapitoken);

    if (jwt.client) {
      // Store tokebn and tenant in local storage
      sessionStorage.setItem('token', icapitoken);
    }
  } else if (eventData.action === 'setIccApiToken') {
    const { client, ...rest } = parse(window.location.search);
    // Retrieve JWT token from data of received message from ICX portal
    let icapitoken = eventData.data.icapitoken;

    if (icapitoken) {
      const jwt = jwtDecode(icapitoken);
      if (jwt.client) {
        // Store token and tenant in local storage
        sessionStorage.setItem('token', icapitoken);
        let jwtClient = jwt.client;
        let isMupTenant = false;
        if (client) {
          sessionStorage.setItem('isMupChild', jwt.client !== client);
          isMupTenant = true;
          jwtClient = client;
        }
        sessionStorage.setItem('isMupTenant', isMupTenant);
        sessionStorage.setItem('tenant', jwtClient);
      }

      // Remove token from URL, leave the rest
      let search = stringify(rest);
      if (search !== '') {
        search = '?' + search;
      }
      window.history.replaceState(
        {},
        'IC New Admin',
        window.location.pathname + search
      );

      portalMode = true;
      // Render the application
      callBack();
    }
  }
};

/**
 * Initialize ICX Portal communication
 */
export const initIcxPortal = callBack => {
  // Handle frame messages posted from ICX Portal
  window.addEventListener(
    // NOSONAR
    'message',
    messageEvent => {
      if (typeof messageEvent.data === 'string') {
        try {
          const eventContent = JSON.parse(messageEvent.data);
          if (eventContent.origin !== 'ICX') return;

          if (eventContent.origin === 'ICX') {
            receiveMessageFromIcx(eventContent, callBack);
          }
        } catch (error) {
          // Do nothing, not a JSON message
        }
      }
    },
    false
  );

  if (isDevMode()) {
    // Dev mode is on -> just render the application
    callBack();
  } else {
    // Dev mode is off, accessing through Portal -> send message to ICX Portal to receive the token
    sendgetIccApiTokenToIcx();
  }

  const sendPingOnMoveThrottled = throttle(sendPingOnMove, 60000);
  window.addEventListener('mousemove', sendPingOnMoveThrottled);
};

const sendPingOnMove = () => {
  sendPingToIcx();
};

/**
 * Check if running in ICX Portal
 */
export const runningInPortal = () => {
  return portalMode;
};

/**
 * Send Ping to ICX Portal
 */
let pingTimeout = undefined;
const PING_TIMEOUT = 60000;

export const sendPingToIcx = () => {
  // 1st test if a sending ping has been forecasted
  if (portalMode && pingTimeout === undefined) {
    // No ping forecasted, let's send it in 1 minute
    pingTimeout = setTimeout(() => {
      pingTimeout = undefined;

      var parentDomain = document.location.ancestorOrigins
        ? document.location.ancestorOrigins[0]
        : document.referrer;
      if (parentDomain === undefined || parentDomain === '') parentDomain = '*';

      // SonarQube: we must send this ping message to our container. No sensitive info sent !
      const msg = '{ "origin": "IcxAdmin", "action": "ping"}';
      window.parent.postMessage(msg, parentDomain); // NOSONAR
    }, PING_TIMEOUT);
  }
};

export const sendgetIccApiTokenToIcx = () => {
  let parentDomain = document.location.ancestorOrigins
    ? document.location.ancestorOrigins[0]
    : document.referrer;
  if (parentDomain === undefined || parentDomain === '') parentDomain = '*';

  // SonarQube: we must send getIccApiToken message to our container so we can get the token from ICX Portal. No sensitive info sent !
  const msg = '{ "origin": "IcxAdmin", "action": "getIccApiToken"}';
  window.parent.postMessage(msg, parentDomain); // NOSONAR
};
